// Browser substitute for ./middleware, wired via the package.json `browser` field.
export const forceExperiments: typeof import('./middleware').forceExperiments =
  () => {
    throw new Error(
      '@mc/next-growthbook: forceExperiments is server-only and cannot run in the browser',
    )
  }

// Compile-time parity guard: errors when ./middleware gains an export this stub lacks.
export const _middlewareExportParity: Omit<
  typeof import('./middleware'),
  keyof typeof import('./middleware.browser')
> = {}
